import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { TransactionDisputeDto } from "@/features/wallet/api/dto";

/**
 * Détail d'une contestation (`GET /TransactionDisputes/{id}`, guide v3.1) :
 * montants contesté / gelé (`heldAmountMinor`) / non gelé, échéance du gel,
 * statut et note de résolution. 404 hors périmètre (sauf back-office :
 * flashpay-superadmin, flashpay-admin, flashpay-service).
 */
export const useTransactionDispute = (
  transactionDisputeId: string,
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_TRANSACTION_DISPUTE_DETAIL(transactionDisputeId),
    queryFn: () =>
      fetchDataGet<TransactionDisputeDto>({
        url: walletEndpoints.transactionDisputes.detail(transactionDisputeId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(transactionDisputeId),
  });
